import React from "react";
import { Helmet } from "react-helmet";

export const Blog = (props) => {
  return (
    <section id="blog" className="text-center">
      <Helmet>
        <title>Blog & Haberler - TR Assist</title>
        <meta name="description" content="Yol yardım sektöründeki son gelişmeler, güvenlik ipuçları ve TR Assist'ten haberler. Araç bakımı, güvenlik önerileri ve sektör analizleri." />
        <meta name="keywords" content="yol yardım blog, araç bakımı, güvenlik ipuçları, sigorta haberleri, TR Assist haberler" />
        <link rel="canonical" href="https://www.trassist.com.tr/#blog" />
        
        {/* Blog için Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Blog",
            "name": "TR Assist Blog",
            "description": "Yol yardım sektöründeki son gelişmeler ve güvenlik ipuçları",
            "url": "https://www.trassist.com.tr/#blog",
            "publisher": {
              "@type": "Organization",
              "name": "TR Assist",
              "logo": "https://www.trassist.com.tr/img/tr_assistance_logo.svg"
            },
            "blogPost": props.data ? props.data.map(blog => ({
              "@type": "BlogPosting",
              "headline": blog.title,
              "description": blog.excerpt,
              "datePublished": `2024-${blog.month}-${blog.day}`,
              "author": {
                "@type": "Organization",
                "name": "TR Assist"
              },
              "image": blog.image,
              "url": `https://www.trassist.com.tr${blog.link}`
            })) : []
          })}
        </script>
      </Helmet>
      
      <div className="container">
        <div className="section-title">
          <h2>Blog & Haberler</h2>
          <p>
            Yol yardım sektöründeki son gelişmeler, güvenlik ipuçları ve TR Assist'ten haberler
          </p>
        </div>
        <div className="row">
          {props.data && props.data.length > 0
            ? props.data
                .filter(d => d.featured === true)
                .map((d, i) => {
                  return (
                    <article key={`${d.title}-${i}`} className="col-md-4 col-sm-6">
                      <div className="blog-item">
                        <div className="blog-image">
                          <img 
                            src={d.image} 
                            className="img-responsive" 
                            alt={`${d.title} - TR Assist Blog`}
                            onError={(e) => {
                              e.target.style.display = 'block';
                              e.target.style.background = '#f0f0f0';
                            }}
                          />
                          <div className="blog-date">
                            <span className="day">{d.day}</span>
                            <span className="month">{d.month}</span>
                          </div>
                        </div>
                        <div className="blog-content">
                          <h3>{d.title}</h3>
                          <p>{d.excerpt}</p>
                          <a 
                            href={d.link} 
                            className="btn btn-custom"
                            aria-label={`${d.title} yazısını oku`}
                          >
                            Devamını Oku
                          </a>
                        </div>
                      </div>
                    </article>
                  );
                })
            : <p>Blog yazıları yükleniyor...</p>}
        </div>
        <div className="row">
          <div className="col-md-12 text-center" style={{ marginTop: '30px' }}>
            <a href="/blogs" className="btn btn-custom btn-lg">
              Tüm Blog Yazılarını Gör
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}; 